export function WatchersDao(XRAY_RESOURCE, XRayUIDaoFactory) {
	return XRayUIDaoFactory()
		.setPath(XRAY_RESOURCE.WATCHES + '/:watcher_name')
		.setCustomActions({
			'getAll': {
				method: 'GET',
				isArray: true
			},
			'getOne': {
				method: 'GET',
				params: {watcher_name: '@watcherName'}
			},
			'getViolations': {
                method: 'POST',
				params: {watcher_id: '@watcherId'},
				path: '/userIssues/byWatch/:watcher_id'
			},
			'getViolationsCount': {
				method: 'GET',
				params: {watcher_id: '@watcherId'},
				path: '/userIssues/countByWatch/:watcher_id'
			},
			'create': {
				method: 'POST',
				notifications: true
			},
			'update': {
				method: 'PUT',
                params: {watcher_name: '@general_data.name'},
				notifications: true
			},
			'delete': {
				method: 'DELETE',
				params: {watcher_name: '@watcherName'}
            },
            'getAllResources': {
                method: 'GET',
                isArray: true,
                path: '/projects/resources'

            }

		})
		.getInstance();
}



// WEBPACK FOOTER //
// ./modules/xray/data/dao/watchers_dao.js